<template>
    <v-tab-item
        eager
    >
        <v-row>
            <v-col cols="12" class="col-sm-2 pa-sm-6">
                <span class="font-weight-medium">{{$t('processingPhases')}}</span>
            </v-col>
            <v-col cols="12" class="col-sm-10">
                <v-tabs
                    v-model="activeTab"
                    active-class=" body-2 font-weight-bold text-capitalize text--main-yellow"
                    slider-color="orange lighten-2"
                    ref="tabs"
                >
                    <v-tab
                        v-for="(tab, idx) in Number(treatmentsCnt)"
                        :key="idx"
                    >T{{ tab-1 }}</v-tab>

                </v-tabs>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-tabs-items
                    v-model="activeTab"
                >
                    <category-tab
                        v-for="(tab, idx) in Number(treatmentsCnt)"
                        :key="idx"
                        :treatmentIdx="tab-1"
                        :calculationIdx="calculationIdx"
                        :categories="categories"
                    >
                    </category-tab>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-tab-item>
</template>

<script>
import CategoryTab from "./CategoryTab";
import Stepper from "../../../../app-front/mixins/Stepper";
export default {
    name: "CultureTab",
    components: { CategoryTab },
    mixins: [ Stepper ],
    props: [ 'calculationIdx', 'categories' ],
    data() {
        return {
            activeTab: 0,

        }
    },
    computed: {
        treatmentsCnt() {
            const calculation =  this.$store.getters.calculatorFullData[this.calculationIdx];
            return (calculation && calculation.treatments) ? calculation.treatments.length : 0;
        }
    }
}
</script>

<style scoped>

</style>
